import { useQuery } from "@tanstack/react-query";
import { programmeDashboardApi } from "../api/programmeDashboard";

export interface VarianceAnalysisData {
  month: string;
  actual: number;
  variance: number;
}

const formatCurrency = (amount: number): number => {
  return amount / 1000000;
};

export const useVarianceAnalysis = ({ portfolio_id, quickFilters }: { portfolio_id: string | undefined, quickFilters: any }) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["variance-analysis", portfolio_id],
    queryFn: () => programmeDashboardApi.fetchVarianceAnalysis(portfolio_id),
  });

  const chartData: VarianceAnalysisData[] = data?.data
    ? data.data.map((item) => ({
      month: item.month,
      actual: formatCurrency(item.totalActualSpend),
      variance: formatCurrency(item.variance),
    }))
    : [];

  return {
    chartData,
    isLoading,
    isError,
    error:
      error instanceof Error
        ? error.message
        : "Failed to fetch variance analysis",
  };
};

